import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoNoteSpeseETrasferteStep2Component
} from './conservazione-carica-documento-note-spese-e-trasferte-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-note-spese-e-trasferte-step2', {
            url: '/conservazione-carica-note-spese-e-trasferte',
            ncyBreadcrumb: {
                label: 'Carica Note Spese e Trasferte',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-note-spese-e-trasferte-step2 flex="100"></conservazione-carica-documento-note-spese-e-trasferte-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoNoteSpeseETrasferteStep2Module: string = ng
    .module('conservazione-carica-documento-note-spese-e-trasferte-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
  .component('conservazioneCaricaDocumentoNoteSpeseETrasferteStep2', ConservazioneCaricaDocumentoNoteSpeseETrasferteStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-note-spese-e-trasferte-step2/conservazione-carica-documento-note-spese-e-trasferte-step2.module.ts